import { Component, OnInit, OnDestroy } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';
import { AddNewUserDialogComponent } from '../add-new-user-dialog/add-new-user-dialog.component';
import { EditUserDialogComponent } from '../edit-user-dialog/edit-user-dialog.component';

import { AdminService, AlertService, CommonService, LeadService } from '../../../_services/';
import { environment } from '../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import * as moment2 from 'moment-timezone';

import * as firebase from 'firebase/app'; // Typescript
// import firebase from 'firebase/app'; // JS
import 'firebase/functions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {
  users:[];
  showroomList:any=[];
  jobFunctionList:any=[];
  userData:any;
  projectList:any[];
  private subscription : Subscription;
  private subscription2 : Subscription;
  private subscription3 : Subscription;
  lastInResponse:any;
  importCounter = 0;
  constructor(
    public dialog: MatDialog,
    private _common : CommonService,
    private _admin : AdminService,
    private _alert : AlertService,
    private _toastr : ToastrService,
    private _lead : LeadService
  ) { }

  ngOnInit() {
    this.importCounter +=1;

    this.getUserList(localStorage.getItem('uid'));
    this.getShowroomList();
    this.getJobFunctionList();

 /*   if(firebase.apps.length < 2){
      const app= firebase.initializeApp(environment.firebaseConfig);
      if(window.location.host.includes('localhost')){
        app.functions().useFunctionsEmulator('http://localhost:5000');
      }
    }
    var db = firebase.firestore();*/
  }

  getShowroomList(){
    this._common.showLoader(true);
    this.subscription = this._admin.geShowroomList().subscribe(result=>{
      this._common.showLoader(false);
      for(let item of result){
        this.showroomList.push({name:item.payload.doc.data()['name'],id:item.payload.doc.id,selected:false})
      }
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }

  getJobFunctionList(){
    this._common.showLoader(true);
    this.subscription2 = this._admin.getJobFunctionList().subscribe(result=>{
      this._common.showLoader(false);
      for(let item of result){
        this.jobFunctionList.push({name:item.payload.doc.data()['name'],id:item.payload.doc.id,selected:false})
      }
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }

  getUserList(uid=null){
    // this._common.showLoader(true);

  /*  this._admin.getAllContacts(this.lastInResponse).subscribe(res=>{
      this.lastInResponse = res.docs[res.docs.length - 1]
      const contactList = res.docs.map(item=> item.data()); 
      console.log(contactList.length,'contactList data!');
      //  if(this.importCounter===1){
        // this.importCounter+=1;
         for(let i=0; i<=contactList.length; i++){
           // Check eligibility criteria
           if(contactList[i] && !contactList[i].date_created_year){
            let time = moment2(contactList[i].date_created).tz('America/New_York').format('YYYY MM DD');
            let time2 = time.split(' ');
            // Update Contact
            const obj = {
              date_created_day : parseInt(time2[2]),
              date_created_month : parseInt(time2[1]),
              date_created_year : parseInt(time2[0])
            }
            this._lead.updateContact(obj,contactList[i].id).then(res=>{
              console.log(i,' value updated for ', contactList[i].id)
            }).catch(err=>{
              console.log(err,'error occured while updating date fields for', contactList[i].id);
            })
          }
          }

        // }

    },err=>{
      console.log('this is error',err);
    }); return;*/
    // this._admin.deleteBatchWise('13638').then(function(querySnapshot) { 
    //   console.log('collection length!!!'); 
    // }); 
    // return; 
/*    this._admin.importRS2DriveFile({}).subscribe(res2=>{
      console.log(res2,'drive file upload status');
      this._common.showLoader(false);
    },err=>{
      console.log('----error while google drive content!!!!',err);
      this._common.showLoader(false);
    })
    return;  */
    // Fetch all projects...
    // 
    // this._admin.getProjectsByUid('9035').subscribe(res=>{
    //   this.projectList = res.docs.map(item=> item.data()); //payload.doc
    //   console.log(this.projectList.length,'projects!');
    //   if(this.importCounter===1){
    //     this.importCounter+=1;
    //     for(let i=0; i<this.projectList.length; i++){ // 
    //       this._admin.importRS2DriveFile({"project_id":this.projectList[i].id,'itrt': i}).subscribe(res2=>{
    //         console.log(res2,'Success:',i,'---',this.projectList[i].id);
    //       },err=>{
    //         console.log(this.projectList[i].id,'Error: ',err.error.message);
    //       })
    //     }  

    //   }

    // },err=>{
    //   console.log('this is error',err);
    // }); return;

    // Drive Files import task ends here
    this._common.showLoader(true);
    this.subscription3 = this._admin.getUserList(uid).subscribe(result=>{
      this._common.showLoader(false);
      this.users = result;
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
    }) 
  }

  openAddNewUserDialog(){
    let dialogRef = this.dialog.open(AddNewUserDialogComponent, {
      width: 'auto',
      data:{
        showroomList: this.showroomList,
        jobFunctionList: this.jobFunctionList
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      this.getUserList(localStorage.getItem('uid'))
    })

  }

  openEditUserDialog(id,user){
    this._lead.getContactDetail2(id).then(res=>{
      // console.log(res,'this is contact data!'); return;
      let dialogRef = this.dialog.open(EditUserDialogComponent, {
        width: 'auto',
        data: {
          id:id,
          showroomList: this.showroomList,
          jobFunctionList: this.jobFunctionList,
          userData : res
        }
      });
      
      dialogRef.afterClosed().subscribe(response => {
        this.getUserList(localStorage.getItem('uid'))
      })
    },err=>{
      console.log(err,'this is test errro!!!!');
      this._common.showLoader(false);
      this._toastr.error(`${ err && err.error  && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });

    })
  
  }

  // delete  user
  deleteUser(id){
    this._common.showLoader(true);
    var functions = firebase.functions();
    let deleteUser = firebase.functions().httpsCallable('delete_user');
    deleteUser({id}).then((result) => {
      this._common.showLoader(false);
      this._toastr.success(`${result.data.message}`,"",{ timeOut: 4000 });      
    },err=>{
      this._common.showLoader(false);
      this._toastr.error(`${ err && err.error  && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });

    });
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
    if(this.subscription3) this.subscription3.unsubscribe();
  }


}
